import React from "react";
import classes from './promptMessage.module.css';

const PromptMessage = (props) => {
    return (
        <div>
            <div className={classes.Overlay} />
            <div className={props.successMessage ? classes.PromptMessage : classes.OopsPromptMessage}>
                <div className={props.status === 'SUCCESS' || props.successMessage ? classes.SuccessStatus : 
                      props.status === 'WARNING' ? classes.WarningStatus : classes.OopsStatus}>
                    {props.status === 'SUCCESS' || props.successMessage ? <div className={classes.Tick}></div> :
                        props.status === 'WARNING' ? <div className={classes.Warning}>!</div> :
                        <div className={classes.Info}>
                            <div/>
                            <div/>
                        </div>}
                </div>
                <h2>{props.status}</h2>
                <p>{props.message}</p>
                <div className={classes.ButtonContainer}>
                    <button onClick={props.click}>{props.button}</button>
                    {props.additionalButton && (
                        <button 
                            className={classes.SecondaryButton} 
                            onClick={props.additionalButtonClick}
                        >
                            {props.additionalButton}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PromptMessage;